import { useIsCollectionsEnabled } from '@modules/common/hooks';
import { useSavedFeedbackListStore } from '@modules/savedFeedbackList/store/useSavedFeedbackListStore';
import { UUID } from 'v2/core/entities/uuid';

export const useGetIsSavedSummary = () => {
  const savedItemsMap = useSavedFeedbackListStore(
    ({ savedItemsMap }) => savedItemsMap,
  );

  const isCollectionsEnabled = useIsCollectionsEnabled();

  return ({
    feedbackID,
    snippetID,
    labelID,
    unitIndex,
  }: {
    feedbackID: UUID;
    snippetID?: UUID;
    labelID?: string;
    unitIndex?: number;
  }) => {
    if (!snippetID) {
      return Boolean(savedItemsMap[feedbackID]?.isRecordSaved);
    }

    if (isCollectionsEnabled) {
      return Boolean(
        savedItemsMap[feedbackID]?.snippetMetadataV2?.some(
          (item) =>
            item.location.keywordSummary?.labelID === labelID &&
            item.location.keywordSummary?.msgIdx === unitIndex,
        ),
      );
    }

    return Boolean(
      savedItemsMap[feedbackID]?.snippetMetadata?.some((item) =>
        item.snippetIDs?.includes(snippetID),
      ),
    );
  };
};
